var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { FormatTypes } from '@monorepo-web/utils';
import { GraficoPDF } from './GraficoPDF';
import * as helperPDF from '../../Biblioteca/helperPDF';
export default class GraficoPizzaPDF extends GraficoPDF {
    constructor(config, svg, title, legendData, addAlphaIndex = false, dataTypeCustodiante = FormatTypes.percentage, moneyPrefix, alignTitle = 'center') {
        super(config, svg, title, legendData);
        if (this.legendData && addAlphaIndex) {
            this.legendData = helperPDF.addAlphaIndex(this.legendData);
        }
        this.dataTypeCustodiante = dataTypeCustodiante;
        this.moneyPrefix = moneyPrefix;
        this.alignTitle = alignTitle;
    }
    /**
     * Gera o componente do gráfico de pizza
     * @param docObj PDF
     * @returns Promise<ComponentPDF | null> Componente do gráfico de pizza
     */
    criarGrafico(docObj) {
        return __awaiter(this, void 0, void 0, function* () {
            const legenda = this.criarLegendaGrafico(docObj);
            return yield this.configurarGrafico(docObj, 60, 60, legenda, this.alignTitle);
        });
    }
    criarLegendaGrafico(docObj) {
        const styles = {
            name: { halign: 'left', valign: 'middle' },
            value: { halign: 'right', valign: 'middle' }
        };
        const body = helperPDF.formatLegendData(this.legendData, docObj.theme.chartColors, styles, 2, [['name', FormatTypes.text], ['value', this.dataTypeCustodiante]], this.moneyPrefix);
        return this.createOptionsTableLegend(body);
    }
    /**
     * Cria os atributos da legenda para o jsPDF
     * @param body Corpo
     * @returns Configurações da legenda
     */
    createOptionsTableLegend(body) {
        const tableOptions = {
            body,
            head: [],
            tableWidth: 70,
            bodyStyles: { fillColor: '#FFFFFF', valign: 'middle' },
            theme: 'plain',
            columnStyles: { 1: { halign: 'left' } },
            rowPageBreak: 'avoid',
            styles: {
                cellPadding: 1.5
            },
        };
        return tableOptions;
    }
}
